module.exports = __webpack_public_path__ + "img/logo-credsis.d35622bb.svg";